// 交易統計 - 繁體中文
export default {
  loading: {
    text: "拼命加載中",
  },
  common: {
    showOnGraph: "上圖",
    none: "--",
  },
  usdt: {
    name: "USDT",
    first: "首筆USDT：",
  },
  fields: {
    earliestIn: "最早轉入",
    latestIn: "最晚轉入",
    earliestOut: "最早轉出",
    latestOut: "最晚轉出",
    inQty: "轉入數量",
    outQty: "轉出數量",
    inAvgQty: "轉入平均數量",
    outAvgQty: "轉出平均數量",
    inCount: "轉入筆數",
    outCount: "轉出筆數",
    inAddressCount: "轉入地址數",
    outAddressCount: "轉出地址數",
  },
  currency: {
    firstPrefix: "首筆",
  },
  bigAddress: {
    empty: "當前地址交易數據過多，暫時不支持此類數據的查看",
  },
};
